import React, { useState, useEffect } from "react";
import axios from "axios";

const AdminCollection = ({ selectedDate }) => {
  const [collections, setCollections] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(true);
  const baseURL = process.env.REACT_APP_BASE_URL;

  // Helper: Format date from DD-MM-YYYY to YYYY-MM-DD
  const formatDate = (date) => {
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  // Fetch collections from the backend
  useEffect(() => {
    if (selectedDate !== "No date selected") {
      const accessToken = sessionStorage.getItem("access_token");
      axios
        .get(`${baseURL}/getAllCollection`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => setCollections(response.data))
        .catch((error) => console.error("Error fetching collections:", error))
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (collections.length > 0 && selectedDate !== "No date selected") {
      const formattedDate = formatDate(selectedDate);

      const filteredCollections = collections.filter(
        (collection) =>
          (collection.scheme_name?.toLowerCase() === "daily collection" ||
            collection.scheme_name?.toLowerCase() === "weekly collection") &&
          collection.date === formattedDate
      );

      const grouped = {};

      filteredCollections.forEach((collection) => {
        const { name, tamilname, scheme_id, scheme_name, emi_amount, loan_id } =
          collection;

        if (!grouped[name]) {
          grouped[name] = {};
        }

        if (!grouped[name][tamilname]) {
          grouped[name][tamilname] = {};
        }

        if (!grouped[name][tamilname][loan_id]) {
          grouped[name][tamilname][loan_id] = {
            scheme_id,
            scheme_name,
            totalAmount: 0,
          };
        }

        const parsedEmiAmount = parseFloat(emi_amount);
        grouped[name][tamilname][loan_id].totalAmount += parsedEmiAmount;
      });

      setGroupedData(grouped);
    }
  }, [collections, selectedDate]);
  console.log(groupedData);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }
  return (
    <div className="p-5 bg-gray-50">
      {/* Header */}
      <div className="bg-gray-200 p-4 rounded-lg flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-2 sm:space-y-0">
        <h1 className="text-base sm:text-lg font-semibold">
          Date: {selectedDate}
        </h1>
      </div>

      {Object.keys(groupedData).map((agentName, index) => (
        <div key={index} className="mt-8">
          <h2 className="text-xl font-bold text-center mb-4">{agentName}</h2>

          <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Loan ID</th>
                <th className="py-2 px-4 text-left">Customer Name</th>
                <th className="py-2 px-4 text-left">Scheme</th>
                <th className="py-2 px-4 text-left">Amount</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedData[agentName]).map((customerName) => {
                const loanIds = Object.keys(
                  groupedData[agentName][customerName]
                );
                return loanIds.map((loanId, rowIndex) => {
                  const { scheme_name, totalAmount } =
                    groupedData[agentName][customerName][loanId];

                  // Apply alternating row colors, starting with white
                  const rowClass =
                    rowIndex % 2 === 0 ? "bg-white" : "bg-gray-100";

                  return (
                    <tr key={`${customerName}-${loanId}`} className={rowClass}>
                      <td className="py-2 px-4">{loanId}</td>
                      <td className="py-2 px-4">{customerName}</td>
                      <td className="py-2 px-4">{scheme_name}</td>
                      <td className="py-2 px-4">{totalAmount}</td>
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default AdminCollection;
